<script setup>
import {useUser} from "../../store/user"
import {useSystem} from "../../store/system";

const userStore = useUser()
const systemStore = useSystem()
//获取所有提现记录
userStore.transactionsLogApi()

</script>

<template>
  <el-row>
    <el-col :span="24">
      <div class="card-bg">
        <div class="tw-p-4 tw-bottom-line tw-font-bold tw-text-[18px]">Transactions Log</div>
        <div class="tw-p-4">
          <el-table
              :data="userStore.getTransactionsLog"
              class="tw-w-full"
          >
            <el-table-column prop="create_time" label="Create Date">
              <template #default="{row, column, $index}">
                <div>{{systemStore.formatDate(row.createtime)}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="message" label="Type">
<!--              <template #default="{row, column, $index}">-->
<!--                <div class="tw-py-1 tw-px-2 tw-bg-blue-500 tw-rounded-md tw-text-center tw-bg-opacity-60" v-if="row.type == 5">Product</div>-->
<!--                <div class="tw-py-1 tw-px-2 tw-bg-green-500 tw-rounded-md tw-text-center tw-bg-opacity-60" v-if="row.type == 6">Profit</div>-->
<!--              </template>-->
            </el-table-column>
            <el-table-column prop="coin_num" label="Amount">
              <template #default="{row, column, $index}">
                <div class="tw-flex tw-justify-start tw-items-center">
                  <span class="tw-mr-1" v-if="row.status == 1">+</span>
                  <span class="tw-mr-1" v-else>-</span>
                  $ {{row.coin_num}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="num_after" label="Balance">
              <template #default="{row, column, $index}">
                $ {{row.num_after}}
              </template>
            </el-table-column>
<!--            <el-table-column prop="message" label="Comments"/>-->
            <template #empty>
              <el-empty :image-size="120"></el-empty>
            </template>
          </el-table>
        </div>
      </div>
    </el-col>
    <el-col :span="24" class="tw-mt-4">
      <el-pagination
          background layout="prev, pager, next"
          :page-size="parseInt(userStore.getTransactionsPage.limit)"
          :total="parseInt(userStore.getTransactionsPage.total)"
          @change="userStore.transactionsChange" />
    </el-col>
  </el-row>
</template>

<style lang="scss">
.el-form-item__label{
  color: $p-text-color !important;
}

.el-table {
  background-color: unset !important;
  color: #FFFFFF;
  border-color: $p-border-color !important;

  // 每行tr的底部线条
  td.el-table__cell, .is-leaf{
    border-bottom: 2px solid $p-border-color !important;
  }

  //解决最后一排边框线
  .el-table__inner-wrapper:before{
    background-color: unset !important;
  }

  .el-table__header-wrapper {
    tr {
      // 表头背景色
      background-color: unset;

      th {
        color: $p-text-color;
        background-color: rgba(0, 0, 0, 0);
      }
    }

  }

  .el-table__body-wrapper {
    tr {
      // 表格内容背景色
      background-color: unset;
      color: $p-text-color;

      &:hover>td {
        //修改(hover)悬浮背景色
        background-color: $p-table-row-active-color !important;
      }
    }
  }
}
</style>
